import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeadGenPage from "./pages/LeadGenPage";

const AppRouter = () => (
  <>
    <Router>
      <Routes>
        <Route path="/" element={<LeadGenPage />} />
      </Routes>
    </Router>
    <ToastContainer
      position="bottom-center"
      autoClose={2500}
      hideProgressBar={true}
      closeButton={false}
      transition={Slide}
      draggable={false}
      pauseOnFocusLoss={false}
      closeOnClick={false}
    />
  </>
);

export default AppRouter;
